<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: ITAT Time      

========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://itassistteam.com/" target="_blank" rel="nofollow">IT Assist Team</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <div class="app-version-label">
          {{ appVersion }}
        </div>
        <!-- <span class="md:flex hidden items-center">
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span> -->
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION
    }
  }
}
</script>

<style scoped>

.app-version-label {
  opacity: .5;
}

</style>